import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <main className="page-canvas">
      <section className="container empty-state">
        <h1>Không tìm thấy trang</h1>
        <p>Route chưa tồn tại hoặc đường dẫn đã thay đổi.</p>
        <Link className="btn btn-primary" to="/">
          <span>Về trang chủ</span>
        </Link>
      </section>
    </main>
  );
}
